module.exports = __webpack_public_path__ + "static/media/success.f03740e8.svg";